export type LeadStage = 
  | 'new_lead' 
  | 'contacted' 
  | 'interested' 
  | 'demo_scheduled' 
  | 'demo_completed' 
  | 'negotiation' 
  | 'won' 
  | 'lost'

export type Priority = 'low' | 'medium' | 'high' | 'urgent'

export type FollowupType = 'call' | 'whatsapp' | 'email' | 'meeting' | 'demo'

export type FollowupStatus = 'pending' | 'completed' | 'missed' | 'rescheduled'

export interface Lead {
  id: number
  coaching_name: string
  owner_name: string
  phone: string
  whatsapp: string
  email: string
  district: string
  student_count: number
  stage: LeadStage
  priority: Priority
  next_followup: string | null
  notes: string
  lead_source: string
  created_at: string
  updated_at: string
}

export interface Followup {
  id: number
  lead_id: number
  scheduled_date: string
  type: FollowupType
  status: FollowupStatus
  notes: string
  completed_at: string | null
  created_at: string
  lead?: Lead
}

export interface Activity {
  id: number
  lead_id: number
  type: 'call' | 'whatsapp' | 'email' | 'meeting' | 'demo' | 'note' | 'stage_change'
  description: string
  created_at: string
}

export interface DashboardStats {
  total_leads: number
  today_followups: number
  interested: number
  won: number
  lost: number
  pipeline: Record<LeadStage, number>
}

export const STAGE_LABELS: Record<LeadStage, string> = {
  new_lead: 'New Lead',
  contacted: 'Contacted',
  interested: 'Interested',
  demo_scheduled: 'Demo Scheduled',
  demo_completed: 'Demo Completed',
  negotiation: 'Negotiation',
  won: 'Won',
  lost: 'Lost'
}

export const STAGE_COLORS: Record<LeadStage, string> = {
  new_lead: 'bg-gray-100 text-gray-700',
  contacted: 'bg-blue-100 text-blue-700',
  interested: 'bg-yellow-100 text-yellow-700',
  demo_scheduled: 'bg-purple-100 text-purple-700',
  demo_completed: 'bg-indigo-100 text-indigo-700',
  negotiation: 'bg-orange-100 text-orange-700',
  won: 'bg-green-100 text-green-700',
  lost: 'bg-red-100 text-red-700'
}

export const PRIORITY_COLORS: Record<Priority, string> = {
  low: 'bg-gray-100 text-gray-600',
  medium: 'bg-blue-100 text-blue-600',
  high: 'bg-orange-100 text-orange-600',
  urgent: 'bg-red-100 text-red-600'
}
